"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.statsd = exports.wrapperStatsdClient = exports.statsdPrefix = void 0;
exports.statsdPrefix = "search.client.";
exports.wrapperStatsdClient = null;
function maybeCallStatsd(func) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!(exports.wrapperStatsdClient === null || exports.wrapperStatsdClient === void 0 ? void 0 : exports.wrapperStatsdClient[func])) {
            console.error("unable to use statsd! unset wrapper!");
        }
        else {
            // @ts-ignore
            exports.wrapperStatsdClient[func].apply(exports.wrapperStatsdClient, __spreadArray([], __read(args), false));
        }
    };
}
exports.statsd = {
    count: maybeCallStatsd("count"),
    timing: maybeCallStatsd("timing"),
};
//# sourceMappingURL=StatsDClient.js.map